/**
 * Empty is a real answer only after the first fetch settles. A refetch that
 * still has no rows must stay on the loading state — `isLoading` is already
 * false once any result, including `[]`, is cached, so the tab would say
 * nothing while the entries are still on the way.
 */
export function invoiceActivityIsLoading(state: {
  isFetched: boolean;
  isFetching: boolean;
  entryCount: number;
}): boolean {
  return !state.isFetched || (state.isFetching && state.entryCount === 0);
}
